import { founders } from '@/mocks/home';

export default function Founders() {
  return (
    <section id="founders" className="bg-foreground-950 px-4 md:px-8 py-16 md:py-24">
      <p className="font-label uppercase tracking-[0.28em] text-xs text-accent-400 font-semibold">Founders</p>
      <h2 className="font-heading font-bold text-5xl md:text-7xl text-background-50 leading-[1.02] mt-3 mb-12">Community over clicks.</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {founders.map((f) => (
          <article key={f.name} className="flex flex-col sm:flex-row gap-5">
            <div className="w-full sm:w-48 h-64 sm:h-60 rounded-lg overflow-hidden shrink-0">
              <img src={f.image} alt={f.name} title={`${f.name}, GreenSide News`} className="w-full h-full object-cover object-top" />
            </div>
            <div className="sm:pt-2">
              <h3 className="font-heading font-bold text-3xl text-background-50">{f.name}</h3>
              <p className="font-label uppercase text-sm tracking-widest text-accent-400 mt-1">{f.role}</p>
              <p className="text-foreground-300 mt-4">{f.bio}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}